module.exports = __webpack_public_path__ + "static/media/League-status-disabled.3bf32fc2.svg";